import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { WorkforceService } from 'src/app/services/workforce.service';
import { EventService } from 'src/app/services/event.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { PhotoComponent } from 'src/app/components/photo';


@Component({
    selector: 'add-workforce-to-group-by-list-dialog',
    template: `
  <div class="add-workforce-to-group-by-list-dialog joi-dialog">
      <div mat-dialog-title>Add to {{data.selectedGroup.name}}</div>
      <div mat-dialog-content>
          <div class="label" [innerHTML]="title"></div>
          <div class="group" *ngFor="let worker of data.workers; index as i">
              <div class="workers name_data action-{{ i }} {{ worker.status }}">
                  <mat-checkbox color="primary" (change)="selectWorker($event, i)">
                      <photo [data]="worker"></photo>
                      <div class="worker_name">{{ worker.firstName + ' ' + worker.lastName }}<span class="role" *ngIf="worker.role">{{' - ' + worker.role}}</span></div>
                  </mat-checkbox>
                  <div class="email" *ngIf="worker.email">{{ worker.email }}</div>
              </div>
          </div>
      </div>
      <div mat-dialog-actions>
          <div style="flex:1;"></div>
          <button mat-button (click)="dialogRef.close()">CANCEL</button>
          <button mat-button color="primary" [disabled]="selected_workers.length==0" (click)="saveWorkers()" tabindex="1">Add</button>
      </div>
  </div>
  `,
    styleUrls: [`./workforce.main.scss`],
    standalone: true,
    imports: [MatCheckboxModule, MatDialogModule, MatButtonModule, CommonModule, PhotoComponent]
})
export class AddWorkforceToGroupByListDialogComponent {

  title = '';
  selected_workers = [];
  constructor(public dialogRef: MatDialogRef<AddWorkforceToGroupByListDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private workforce: WorkforceService, public event: EventService) {
  }
  selectWorker(evt, i) {
    const idx = this.selected_workers.indexOf(i);
    if (evt.checked && idx < 0) {
      this.selected_workers.push(i);
    } else if (!evt.checked && idx > -1) {
      this.selected_workers.splice(idx, 1);
    }
  }
  saveWorkers() {
    const that = this;
    const promise_arr = this.selected_workers.map(w => this.workforce.addMemberToGroup(that.data.workers[w].email, that.data.selectedGroupIndex));
    Promise.all(promise_arr).then(results => {
      this.dialogRef.close()
    }).catch(err => {
      console.error("Error: ", { err })
    })
  }
}
